"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_redux_1 = require("react-redux");
const ui_1 = require("../ui");
const common_1 = require("../../../common");
const HostsClusterDetailTabContent_1 = require("./HostsClusterDetailTabContent");
const store_1 = require("../../store");
const use_feature_detection_1 = require("../../hooks/use-feature-detection");
const HostsClusterDetailTab = (props) => {
    (0, use_feature_detection_1.useFeatureDetection)(props.allEnabledFeatures);
    return (react_1.default.createElement(react_redux_1.Provider, { store: store_1.storeDay1 },
        react_1.default.createElement(ui_1.AssistedUILibVersion, null),
        react_1.default.createElement(common_1.AlertsContextProvider, null,
            react_1.default.createElement(HostsClusterDetailTabContent_1.HostsClusterDetailTabContent, Object.assign({}, props)))));
};
exports.default = HostsClusterDetailTab;
//# sourceMappingURL=HostsClusterDetailTab.js.map